// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"e4cbefe3","845":"1c74614a"}[chunkId] + ".chunk.js";
};